import React from "react";
import { makeStyles } from "@material-ui/styles";
import classNames from "classnames";
import styleConstants from "../../styleConstants";

const useStyles = makeStyles({
  container: {
    backgroundColor: styleConstants.colors.themeBlueLight,
    display: "flex",
    alignItems: "center",
    padding: "1rem",
    marginBottom: "1rem"
  },
  icon: {
    marginRight: "1rem",
    display: "flex",
    alignItems: "center"
  },
  content: {
    color: styleConstants.colors.themeBlue,
    fontWeight: styleConstants.fontWeights.medium,
    lineHeight: "1.25"
  }
});

const Aside = props => {
  const classes = useStyles();

  return (
    <div className={classNames("aside", classes.container)}>
      <div className={classes.icon}>
        <img width="32px" height="32px" src={props.icon} alt="icon" />
      </div>
      <div className={classes.content}>{props.children}</div>
    </div>
  );
};

export default Aside;
